module.exports = __webpack_public_path__ + "assets/img/bg.a2bd78f7.png";